import boxShadow from "../functions/boxShadow";
import rgba from "../functions/rgba";
import colors from "./colors";

const { black, primary, secondary, info, success, warning, error, light, dark } = colors;

const boxShadows = {
  xs: boxShadow([0, 2], [9, -5], black.main, 0.15),
  sm: boxShadow([0, 5], [10, 0], black.main, 0.12),
  md: `${boxShadow([0, 4], [6, -1], black.main, 0.1)}, ${boxShadow([0, 2], [4, -1], black.main, 0.06)}`,
  lg: `${boxShadow([0, 10], [15, -3], black.main, 0.1)}, ${boxShadow([0, 4], [6, -2], black.main, 0.05)}`,
  xl: `${boxShadow([0, 20], [25, -5], black.main, 0.1)}, ${boxShadow([0, 10], [10, -5], black.main, 0.04)}`,
  xxl: boxShadow([0, 20], [27, 0], black.main, 0.05),
  inset: boxShadow([0, 1], [2, 0], black.main, 0.075, "inset"),

  colored: {
    primary: boxShadow([0, 4], [20, 0], primary.main, 0.14),
    secondary: boxShadow([0, 4], [20, 0], secondary.main, 0.14),
    info: boxShadow([0, 4], [20, 0], info.main, 0.14),
    success: boxShadow([0, 4], [20, 0], success.main, 0.14),
    warning: boxShadow([0, 4], [20, 0], warning.main, 0.14),
    error: boxShadow([0, 4], [20, 0], error.main, 0.14),
    light: boxShadow([0, 4], [20, 0], light.main, 0.14),
    dark: boxShadow([0, 4], [20, 0], dark.main, 0.14),
  },

  navbarBoxShadow: `${boxShadow([0, 0], [1, 1], rgba(black.main, 0.05), 0)}, ${boxShadow(
    [0, 20],
    [27, 0],
    black.main,
    0.05
  )}`,
};

export default boxShadows;
